var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"incomeAll"},[_c('h6',[_vm._v("使用介绍")]),_c('div',{staticClass:"shiYong fwbhtml",domProps:{"innerHTML":_vm._s(_vm.introduce)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }